/* eslint-env browser */
import _ from 'lodash';

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { selectors as localeSelectors } from 'frontend/state/reducers/locale';

import config from 'frontend/config';

export const sizeMap = {
  small: 18,
  medium: 36,
  large: 56,
};

export const itemBadge = item => {
  const badge = {
    text: null,
    title: null,
    size: 12,
    color: config.colors.darkblue,
  };

  if (item.source === 'weekly_reward') {
    badge.text = 'GV';
    badge.title = 'Great Vault Item';
    badge.color = config.colors.purple;
  } else if (item.source === 'token') {
    badge.text = 'TOK';
    badge.title = 'Weapon Token';
    badge.color = config.colors.midgray;
  } else if (item.customItem) {
    badge.text = 'DRP';
    badge.size = 11;
    badge.title = 'Custom Drop';
    badge.color = config.colors.darkblue;
  }

  let result = null;
  if (badge.text) {
    result = badge;
  }

  return result;
};

const styles = {
  azeriteBorderWrap: {
    position: 'relative',
  },
  azeriteBorderImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
  },
  dull: {
    opacity: 0.4,
    filter: 'grayscale(25%)',
  },
  highlight: {
    backgroundColor: config.colors.orange,
  },
};

const HIDE_GEM_ITEM_IDS = [
  167555,
];

class WowIcon extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    alt: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    type: PropTypes.string,
    quality: PropTypes.number,
    source: PropTypes.string,
    extra: PropTypes.shape({
      bonus: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ench: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      gems: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      setPieces: PropTypes.array,
      relics: PropTypes.array,
      azerite: PropTypes.string,
    }),
    dull: PropTypes.bool,
    highlight: PropTypes.bool,
    border: PropTypes.string,
    borderStyle: PropTypes.string,
    noLink: PropTypes.bool,
    showAzeriteBorder: PropTypes.bool,
    locale: PropTypes.string,
    subscript: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  static defaultProps = {
    alt: '',
    size: 'medium',
    icon: null,
    id: null,
    type: null,
    quality: null,
    source: 'wowhead',
    extra: null,
    dull: false,
    highlight: false,
    border: null,
    borderStyle: 'solid',
    noLink: false,
    showAzeriteBorder: false,
    locale: null,
    subscript: null,
  };

  componentDidMount() {
    if (this.linkNode && window.CurseTips) {
      window.CurseTips['wowdb-tooltip'].watchElements(this.linkNode);
    }
  }

  componentDidUpdate() {
    if (this.linkNode && window.CurseTips) {
      window.CurseTips['wowdb-tooltip'].watchElements(this.linkNode);
    }
  }

  render() {
    const {
      icon,
      alt = '',
      size,
      id,
      type,
      quality,
      source,
      extra,
      dull,
      highlight,
      border,
      borderStyle,
      noLink,
      showAzeriteBorder,
      locale,
      subscript,
    } = this.props;

    let sizePx;
    let sourceSize;
    if (sizeMap[size]) {
      sizePx = sizeMap[size];
      sourceSize = sizePx;
    } else if (_.isInteger(size)) {
      sizePx = size;
      sourceSize = sizeMap.large;
    } else {
      sourceSize = sizeMap.medium;
      sizePx = sourceSize;
    }
    let url;
    if (icon) {
      url = `https://www.raidbots.com/static/images/icons/${sourceSize}/${icon || 'inv_misc_questionmark'}.png`;
    } else {
      url = `/icon/${sourceSize}/id/${type}/${id}.png`;
    }
    //const url = `/icon/${sizeMap[size]}/${icon || 'inv_misc_questionmark'}.jpg`;
    let qualityBorder = '';
    if (quality) {
      const borderSize = sizePx < sizeMap.medium ? 1 : 2;
      qualityBorder = `${borderSize}px ${borderStyle} ${config.colors.items[quality]}`;
    }
    let result = (
      <img
        src={url}
        alt={alt}
        width={sizePx}
        height={sizePx}
        style={{
          width: sizePx,
          height: sizePx,
          border: border || qualityBorder,
        }}
      />
    );
    if (showAzeriteBorder) {
      result = (
        <div style={styles.azeriteBorderWrap}>
          {result}
          <img
            style={styles.azeriteBorderImage}
            src={`/images/icons/${sourceSize}/azerite-border.png`}
            width={sizePx}
            height={sizePx}
            alt=""
          />
        </div>
      );
    }
    let onClick = () => {};
    if (noLink) {
      onClick = e => {
        if (noLink) {
          e.preventDefault();
        }
      };
    }
    if (id && type) {
      // allow referrer for wowhead
      let rel = 'noopener';

      if (source === 'wowhead') {
        let wowheadData = '';
        let wowheadExtra = {};
        if (extra) {
          wowheadExtra = { ...extra };
          wowheadExtra.pcs = _.replace(wowheadExtra.setPieces, /,/g, ':');
          wowheadExtra.setPieces = undefined;
          if (!_.includes(HIDE_GEM_ITEM_IDS, id)) {
            wowheadExtra.gems = _.replace(wowheadExtra.gems, /,/g, ':');
          }
          if (wowheadExtra.relics) {
            wowheadExtra.gems = wowheadExtra.relics.map(r => r.itemId).join(':');
            wowheadExtra.gem1bonus = _.join(_.get(wowheadExtra, 'relics[0].bonusLists', []), ':');
            wowheadExtra.gem2bonus = _.join(_.get(wowheadExtra, 'relics[1].bonusLists', []), ':');
            wowheadExtra.gem3bonus = _.join(_.get(wowheadExtra, 'relics[2].bonusLists', []), ':');
            delete wowheadExtra.relics;
          }
          if (wowheadExtra.azerite) {
            const [classId, , ...powers] = wowheadExtra.azerite.split(':');
            wowheadExtra['azerite-powers'] = [classId, ...powers].join(':');
            delete wowheadExtra.azerite;
          }
          wowheadData = _.map(_.pickBy(wowheadExtra), (val, key) => `${key}=${val}`).join('&');
        }
        const localeMap = {
          en_US: 'www',
          de_DE: 'de',
          es_ES: 'es',
          fr_FR: 'fr',
          it_IT: 'it',
          pt_BR: 'pt',
          ru_RU: 'ru',
          // ko
          // cn
        };
        const subdomain = localeMap[locale] || 'www';
        let wowheadUrl = `//${subdomain}.wowhead.com/${type}=${id}?${wowheadData}`;
        if (_.includes(['azerite-essence', 'azerite-essence-power'], type)) {
          wowheadUrl = `//${subdomain}.wowhead.com/${type}/${id}?${wowheadData}`;
        }
        result = (
          <a
            href={wowheadUrl}
            rel={rel}
            data-wowhead={wowheadData}
            // this is handled above
            // eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
            onClick={onClick}
          >
            {result}
          </a>
        );
      } else if (source === 'wowdb') {
        if (extra) {
          const keyMap = {
            bonus: 'bonusIDs',
            ench: 'enchantment',
            gems: 'gems',
            setPieces: 'setPieces',
            ilvl: 'itemLevelOverride',
            azerite: 'azerite',
          };
          const bonusIds = extra.bonus;
          if (bonusIds && _.isString(bonusIds)) {
            extra.bonus = bonusIds.replace(/:/g, ',');
          }
          if (extra.relics) {
            extra.gems = extra.relics.map(relic =>
              [
                relic.itemId,
                ...relic.bonusLists,
              ].join(':'),
            ).join(',');
            delete extra.relics;
          }
          rel = _.map(_.pickBy(extra), (val, key) => `${keyMap[key]}=${val}`).join('&');
        }
        const typeMap = {
          spell: 'spells',
          item: 'items',
        };
        let wowdbUrl = `//www.wowdb.com/${typeMap[type]}/${id}`;
        if (rel) {
          wowdbUrl += `?${rel}`;
        }
        result = (
          <a
            href={wowdbUrl}
            rel="noopener"
            // allow referrer for wowdb
            // eslint-disable-next-line
            target="_blank"
            ref={link => { this.linkNode = link; }}
            onClick={onClick}
          >
            {result}
          </a>
        );
      }
    }
    if (subscript) {
      result = (
        <div
          style={{ position: 'relative' }}
        >
          {result}
          <div
            style={{
              fontFamily: 'Tahoma',
              fontSize: sizePx * 0.4,
              position: 'absolute',
              bottom: 0,
              right: 0,
              background: 'rgba(0, 0, 0, 0.9)',
              padding: '1px 0px 0px 1px',
              margin: 0,
              lineHeight: 1,
              pointerEvents: 'none',
            }}
          >
            {subscript}
          </div>
        </div>
      );
    }
    if (dull) {
      result = (
        <span
          key={`icon-${type}-${id}`}
          style={styles.dull}
        >
          {result}
        </span>
      );
    } else if (highlight) {
      result = (
        <span
          key={`icon-${type}-${id}`}
          style={styles.highlight}
        >
          {result}
        </span>
      );
    }
    return result;
  }
}

const mapStateToProps = state => ({
  source: 'wowhead',
  locale: localeSelectors.locale(state).locale,
});

export default connect(mapStateToProps)(WowIcon);
